import Select from 'ol/interaction/Select';
import SearchFeature from 'ol-ext/control/SearchFeature';
import { itineraryPlacesData } from './source.js';

export var select = new Select({
  style: null,
});

function getTitle(feature) {
  var searchedTxt = feature.get('place_name_variants');
  return (searchedTxt);
}


//Set the control grid reference
export var search = new SearchFeature({
  source: itineraryPlacesData,
  getTitle: getTitle,
  className: "search_places",
  title: "Search places",
  placeholder: "Search in places",
  maxHistory: -1,
  maxItems: 5,
  collapsed: false,
  noCollapse: true,
  minLength: 1,
  autocomplete: function (s) {
    s = s.toLowerCase();
    s = s.normalize("NFD").replace(/\p{Diacritic}/gu, "");
    var result = [];
    var regex = new RegExp(s.replace(/^\*/, ''), 'i');
    var features = this.source_.getFeatures();

    for (var i = 0, f; f = features[i]; i++) {
      if (regex.test(getTitle(f).normalize("NFD").replace(/\p{Diacritic}/gu, ""))) {
        result.push(f);
      }
    }

    result.sort(function (left, right) {
      return getTitle(left).toLowerCase().indexOf(s) < getTitle(right).toLowerCase().indexOf(s) ? -1 : 1;
    });

    return result;
  },
});

